import { ResolveAttentionFindingsRequest } from '@/features/dashboard/attention/types/ResolveAttentionFindingsRequest.ts';

interface ResolveAttentionFindingsForm {
  findingIds: string[];
  comment?: string;
}

export const resolveAttentionFindingsRequestMapper = {
  // Biały komentarz to brak komentarza — tak samo normalizuje go backend, więc wysyłamy to, co zapisze.
  fromFormToDto({
    findingIds,
    comment,
  }: ResolveAttentionFindingsForm): ResolveAttentionFindingsRequest {
    return { findingIds, comment: comment?.trim() || null };
  },
};
